import { useCallback } from 'react';
import { HISTORY_LIMIT, useStore } from '~/store';
import { type History, historyEqual, pickHistory } from './partialize';

export function useDragHistory() {
  return useCallback(() => {
    const before = pickHistory(useStore.getState());
    useStore.temporal.getState().pause();
    return () => {
      const t = useStore.temporal.getState();
      const after = pickHistory(useStore.getState());
      t.resume();
      if (historyEqual(before, after)) return;
      const next = [...t.pastStates, before as Partial<History>];
      useStore.temporal.setState({
        pastStates: next.slice(-HISTORY_LIMIT),
        futureStates: [] as Partial<History>[],
      });
    };
  }, []);
}
